export enum InOutType {
  IN,
  OUT,
}
